// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationItem-module--wrapper--2nFPH","link":"NavigationItem-module--link--lC7Er"};